import { Component, EventEmitter, HostListener, Input, Output } from '@angular/core';
import { AcompanhamentoOrdenacaoOption } from '../models/acompanhamento-pedagogico.types';
import { getOrdenacaoIcone } from '../utils/acompanhamento-pedagogico.utils';

/**
 * Dropdown de ordenação da tela de acompanhamento pedagógico. Fecha ao clicar
 * fora (HostListener document:click) — o fechamento por tecla Escape continua
 * no componente pai, que decide a prioridade entre este dropdown e os modais
 * de confirmação/formulário (ver `onEscape` em AcompanhamentoPedagogicoComponent).
 */
@Component({
  selector: 'app-acompanhamento-ordenacao-dropdown',
  templateUrl: './acompanhamento-ordenacao-dropdown.component.html'
})
export class AcompanhamentoOrdenacaoDropdownComponent {
  @Input() aberta = false;
  @Input() opcoes: AcompanhamentoOrdenacaoOption[] = [];
  @Input() selecionada: AcompanhamentoOrdenacaoOption | null = null;

  @Output() toggle = new EventEmitter<void>();
  @Output() selecionar = new EventEmitter<AcompanhamentoOrdenacaoOption>();
  @Output() fechar = new EventEmitter<void>();

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent): void {
    const target = event.target as HTMLElement;

    if (!target.closest('[data-ordenacao-dropdown]')) {
      this.fechar.emit();
    }
  }

  getOrdenacaoIcone(opcaoId: string): string {
    return getOrdenacaoIcone(opcaoId);
  }
}
